import { Button } from "components/button";
import { ToggleKanban } from "components/toggleKanban";
import React from "react";
import { useNavigate } from "react-router-dom";

const TitleDashboard = ({
	children,
	urlAdd = "Create",
	typeAdd = false,
	handleDeleteFile = () => {},
	typeExport = false,
	typeDelete = false,
	isToggleKanban = false,
}) => {
	const navigate = useNavigate();
	return (
		<div className='flex items-center justify-between flex-wrap gap-y-2 gap-x-3'>
			{isToggleKanban ? (
				<ToggleKanban title={children}></ToggleKanban>
			) : (
				<h2 className='title-primary'>{children}</h2>
			)}
			<div className='wrap-button flex items-center gap-x-2 sm:gap-x-5 flex-wrap'>
				{typeAdd && (
					<Button
						onClick={() => navigate(urlAdd)}
						kind='addSecond'></Button>
				)}
				{typeExport && <Button kind='export'></Button>}
				{typeDelete && (
					<Button onClick={handleDeleteFile} kind='delete'></Button>
				)}
			</div>
		</div>
	);
};

export default TitleDashboard;
